'user strict';

import { createSelector } from 'reselect';
import { getOrdersMap as getJobsMap } from '../orders/selectors';

export const getJobIds = ({ jobsTable }) => jobsTable;

export const getJobs = createSelector(
	[ getJobsMap, getJobIds ],
	(jobs, jobIds) => jobIds.map(_id => jobs[ _id ])
);
